import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import i18next from 'i18next';

import { Checkbox } from '../../../common';

import { getTermsOfUseByLanguageAndMarketChannel } from '../claimbot.utils';

import styles from './TermsAndConditionPPU.module.css';

const ParagraphWithTitle = ({ title = '', description = '' }) => (
  <div className={styles.paragraphContainer}>
    <h2 className={styles.contentTitle}>{title}</h2>

    <p className={styles.contentDescription}>{description}</p>
  </div>
);

/**
 * Terms and conditions for both PPU PetCare and Spot Can.
 */
export const TermsAndConditionPPU = ({
  marketingChannelId = 0,
  onAgreePolicyHolderChange = () => { },
  onTermsOfUseChange = () => { },
  termsAndCondPPUSelected = {
    policyHolderDeclaration: false,
    readAndUnderstandTermsOfUse: false,
  },
}) => {
  const { t } = useTranslation('fileClaimbot');

  const ppuTermsLink = useMemo(() => (
    getTermsOfUseByLanguageAndMarketChannel({
      language: i18next.language,
      marketingChannelId,
    })
  ), [i18next.language, marketingChannelId]);

  return (
    <section className={styles.mainContainer}>
      <ParagraphWithTitle
        description={t('termsConditionPPU.termsOfUseContent')}
        title={(
          <Trans
            components={{
              customLink: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  className={styles.customLink}
                  href={ppuTermsLink}
                  rel="noopener noreferrer"
                  target="_blank"
                />
              ),
            }}
            i18nKey="termsConditionPPU.termsOfUseTitle"
            t={t}
          />
        )}
      />

      <ParagraphWithTitle
        description={t('termsConditionPPU.declarationContent')}
        title={t('termsConditionPPU.declarationTitle')}
      />

      <div className={styles.checkboxesContainer}>
        <Checkbox
          checkboxLabelCustom={styles.checkLabel}
          checked={termsAndCondPPUSelected.policyHolderDeclaration}
          label={t('termsConditionPPU.agreeDeclaration')}
          onChange={onAgreePolicyHolderChange}
        />

        <Checkbox
          checkboxLabelCustom={styles.checkLabel}
          checked={termsAndCondPPUSelected.readAndUnderstandTermsOfUse}
          label={(
            <Trans
              components={{
                customLink: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                  <a
                    className={styles.customLinkUnderline}
                    href={ppuTermsLink}
                    rel="noopener noreferrer"
                    target="_blank"
                  />
                ),
              }}
              i18nKey="termsConditionPPU.certifyTermsOfUse"
              t={t}
            />
          )}
          onChange={onTermsOfUseChange}
        />
      </div>
    </section>
  );
};
